// extracted by mini-css-extract-plugin
export default {"reactTopNavGravatar":"ReactGravatar__reactTopNavGravatar__1fybp"};